export default __webpack_public_path__ + "static/media/Q4.5f455c17.jpg";